import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import ProductSalesDetail from "./ProductSalesDetail";

export default {
    storageKey: StorageKey.report_product_purchases_detail,
    getReportLabel: () => t`Product Purchase Detail`,
    required: [
        'date',
        'number',
        'net_amount',
    ],
    defaulto: [
        'description',
        'quantity',
        'unit_price',
    ],
    getColumns: ProductSalesDetail.getColumns,
};
